import { render, staticRenderFns } from "./AllBizLocEmissionByScope.vue?vue&type=template&id=c8c156b8"
import script from "./AllBizLocEmissionByScope.vue?vue&type=script&lang=js"
export * from "./AllBizLocEmissionByScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports